import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
declare var $: any;
@Component({
  selector: 'app-stockmanagementanimals',
  templateUrl: './stockmanagementanimals.component.html',
  styleUrls: ['./stockmanagementanimals.component.css']
})
export class StockmanagementanimalsComponent implements OnInit {
 addstockUrl= "/dashboard/addstockmanagement";
  backUrl="/dashboard/mastermodule";
  liststockUrl="/dashboard/stockmanagement"
  loginresponse:any;
  getlistApi:any;
  userrole:any;
  Getallspecies:any;
  farm_userrole:any;
  constructor(private router: Router,private commonService: CommonService) { }
  async ngOnInit() {
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
   if(this.farm_userrole){
    this.getlistApi= "/species/counts/all/?farm_user="+this.farm_userrole;
   }
   else{
    this.getlistApi= "/species/counts/all";
   }
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    res => {
      this.Getallspecies=res.data;
    })
  }
  listview(){
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    if(this.userrole==1){
    // this.isDisabled = true;
    this.router.navigate([this.liststockUrl]);
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
    else{
      this.router.navigate([this.addstockUrl]);
    }
   
  }
 
  backtomastermodule(){
    this.router.navigate([this.backUrl]);
  }
}
